<template>
  <div class="stepper-container">
    <div
      v-for="(step, index) in steps"
      :key="index"
      class="step-item"
      :class="getStepClass(index + 1, step.enabled)"
    >
      <div v-if="isFailed && currentStep === index + 1" class="step-number">
        !
      </div>
      <div v-else class="step-number">{{ index + 1 }}</div>
      <div class="step-title">{{ step.title }}</div>
    </div>
  </div>
</template>

<script setup>
import { toRefs } from "vue";
const props = defineProps({
  steps: { type: Array, required: true },
  currentStep: { type: Number, required: true },
  isFailed: { type: Boolean, default: false },
});
const { steps, currentStep, isFailed } = toRefs(props);
const getStepClass = (stepIndex, isEnabled) => {
  if (!isEnabled) {
    return "is-disabled";
  }
  if (
    stepIndex < currentStep.value ||
    (currentStep.value === steps.value.length &&
      steps.value.length === stepIndex)
  ) {
    return "is-completed";
  } else if (stepIndex === currentStep.value) {
    return isFailed.value ? "is-failed" : "is-current";
  } else {
    return "is-pending";
  }
};
</script>

<style scoped>
/* 响应式优化：增加最小宽度，防止步骤条被过度压缩 */
.stepper-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin: 0.5rem 0 0 0;
  padding: 0 2rem;
  box-sizing: border-box;
  min-width: 800px;
}
.step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  position: relative;
  transition: all 0.3s ease;
}
.step-item:not(:last-child)::after {
  content: "";
  position: absolute;
  top: 6.5rem;
  left: 50%;
  height: 3px; /* 样式优化：加粗连接线 */
  width: 100%;
  background-color: #dcdfe6;
  z-index: 1;
}
/* 样式优化：增大圆形和数字 */
.step-number {
  width: 11rem;
  height: 11rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 3rem;
  border: 4px solid;
  transition: all 0.3s ease;
  z-index: 2;
  background-color: #fff;
}
.step-title {
  margin-top: 0.5rem;
  font-size: 2rem;
  color: #888;
  white-space: nowrap;
}
.is-pending .step-number {
  border-color: #dcdfe6;
  color: #c0c4cc;
}
.is-pending .step-title {
  color: #c0c4cc;
}
.is-current .step-number {
  border-color: #409eff;
  background-color: #409eff;
  color: #fff;
}
.is-current .step-title {
  color: #409eff;
  font-weight: bold;
}
.is-failed .step-number {
  border-color: red;
  background-color: red;
  color: #fff;
}
.is-failed .step-title {
  color: red;
  font-weight: bold;
}
.is-completed .step-number {
  border-color: #67c23a;
  background-color: #67c23a;
  color: #fff;
}
.is-completed .step-title {
  color: #67c23a;
}
.is-completed::after {
  background-color: #67c23a !important;
}
.is-disabled .step-number {
  border-color: #e4e7ed;
  background-color: #f5f7fa;
  color: #c0c4cc;
}
.is-disabled .step-title {
  color: #c0c4cc;
  text-decoration: line-through;
}
.is-disabled::after {
  background-color: #e4e7ed;
}
</style>
